import { SubscriptionShop } from "../../../../../shop/frontend/web/js/classes/SubscriptionShop.js";
import { utils } from "../utils";
import { MAX_INPUT, MIN_INPUT } from "../constants";

/**
 *  Класс описывающий реализацию абонемента
 * @extends SubscriptionShop
 */
export class Subscription extends SubscriptionShop {
	constructor() {
		super();
		this.$placeToSvg = null;
		this.$subscriptionMain = $("#js-subscription-main");
		this.subscriptionCount = this.$subscriptionMain.data("count");
		this.$checkboxes = $(".js-subscription-checkbox");
		this.allCheckboxesLength = this.$checkboxes.length;
		this.$checkboxAll = $("#js-checkbox-all");
		this.$checkedCount = $(".js-subscription-checked");
		this.$selectedCount = $(".js-subscription-selected");
		this.$items = $(".subscription__items");
		this.$input = $("#js-subscription-input");
		this.$minus = $("#js-subscription-minus");
		this.$plus = $("#js-subscription-plus");
		this.$buy = $("#js-subscription-buy");
		this.$changeCount = $("#js-subscription-count");
		this.$changeSeatsButton = $(".js-change-seats");
		this.$chooseSeatButton = $(".js-subscription-choose");
		this.$subscriptionLine = $(".subscription__line");
		this.$choosePlaces = null;
		this.zones = null;
		this.$ticketsItems = null;
		this.$sum = $("#js-subscription-score");
		this.$placesCancel = null;
		this.$placesOpen = $(".js-places-open");
		this.prices = [];
		this.$eventsBuy = $(".events__buy");
		this.$subscriptionBuy = $(".subscription__buy");
	}

	init() {
		this.getLanguages();
		this.setEventId();
		this.setUpListeners();
		this.updateCheckbox();
		this.updateInput();
		this.addActionToChooseSeat();
		this.getChange();
		this.updateLayoutOnMobile();
		this.toggleEvent();
		this.changeSeats();
		utils.toTop(this.$items);

		this.calculateTotalSumm();
	}

	setUpListeners() {
		if (this.isDesktop.matches) {
			$(document).on("mouseover", e => {
				const element = $(e.target);
				if (element.closest("g[mode]").length) {
					const activeSector = $(element).closest("g[mode]");
					const mode = Number(activeSector.attr("mode"));
					let name =
						activeSector.data("name") ||
						activeSector.attr("sector_name") ||
						activeSector.attr("sector-name");
					let price = activeSector.data("price") || activeSector.attr("price");
					const count = activeSector.attr("all");
					const free = activeSector.attr("free");
					if (mode === 1 && name.indexOf("Сектор") === -1) {
						name = "Сектор " + name;
					}
					this.addTooltip(activeSector, price, name, count, free);
				} else {
					if (this.$tooltip) {
						this.$tooltip.hide();
						this.$tooltip.css({ left: 0, top: 0 });
					}
				}
			});

			this.$eventsBuy.on("mouseout", e => {
				const element = $(e.currentTarget);
				element.blur();
			});

			this.$subscriptionBuy.on("mouseout", e => {
				const element = $(e.currentTarget);
				element.blur();
			});
		}
	}

	setEventId() {
		this.eventId = this.$subscriptionMain.data("event");
		if (!this.eventId) {
			this.eventId = $(".subscription_index").data("event");
		}
	}

	updateCheckbox() {
		this.$checkboxes.on("change", e => {
			const checkbox = $(e.target);
			const parent = checkbox.parents(".subscription__item");
			const checked = $(".js-subscription-checkbox:checked").length;
			this.$checkedCount.text(checked);
			if (checkbox.is(":checked")) {
				parent.find(".subscription__choose").removeClass("inactive");
			} else {
				parent.find(".subscription__choose").addClass("inactive");
				parent.find(".js-change-seats").remove();
				this.getCartCount(this.eventId).then(res => {
					this.updateOtherSubscriptionSeats(res);
					this.calculateTotalSumm();
				});
			}

			if (checked < this.allCheckboxesLength) {
				this.$checkboxAll.prop("checked", false);
			}

			if (checked === this.allCheckboxesLength) {
				this.$checkboxAll.prop("checked", true);
			}

			this.calculateTotalSumm();
		});

		this.$checkboxAll.on("change", () => {
			if (this.$checkboxAll.is(":checked")) {
				this.$checkboxes.prop("checked", true);
				this.$checkedCount.text(this.allCheckboxesLength);
				$.each(this.$checkboxes, (index, elem) => {
					const checkbox = $(elem);
					const parent = checkbox.parents(".subscription__item");
					let count = parent.find(".tickets__item").length;
					this.subEventId = parent.data("event");
					parent.find(".subscription__choose").removeClass("inactive");
					if (!count) {
						parent.find(".subscription__choose").show();
					}
				});
				if (this.eventId) {
					this.addAllEvents().then(() => {
						this.calculateTotalSumm();
					});
				}
			} else {
				this.$checkboxes.prop("checked", false);
				this.$checkedCount.text(0);
				$(".subscription__score-old-price").hide();
				$.each(this.$checkboxes, (index, elem) => {
					const checkbox = $(elem);
					const parent = checkbox.parents(".subscription__item");
					this.subEventId = parent.data("event");
					if (!checkbox.is(":checked")) {
						parent.find(".subscription__line").remove();
					}
					parent.find(".subscription__choose").show().addClass("inactive");
				});
				$(".js-subscription-selected").text(0);
				this.removeAllEvents().then(() => {
					this.getCartCount().then(() => {
						this.calculateTotalSumm();
					});
				});
			}
		});
	}

	updateInput() {
		this.$plus.on("click", () => {
			const value = Number(this.$input.val());

			this.$input.val(value + 1);
			if (this.$input.val() > MAX_INPUT || Number(this.$input.val()) === MAX_INPUT) {
				this.$input.val(MAX_INPUT);
				this.$plus.attr("disabled", true);
			}
			this.$minus.removeAttr("disabled");
		});

		this.$minus.on("click", () => {
			const value = Number(this.$input.val());

			this.$plus.removeAttr("disabled");
			this.$input.val(value - MIN_INPUT);
			if (this.$input.val() < MIN_INPUT || Number(this.$input.val()) === MIN_INPUT) {
				this.$input.val(MIN_INPUT);
				this.$minus.attr("disabled", true);
			}
		});

		this.$input.on("input", () => {
			const value = Number(this.$input.val());

			if (value > MIN_INPUT) {
				this.$minus.removeAttr("disabled");
			} else {
				this.$minus.attr("disabled", true);
			}
			if (value === MAX_INPUT || value > MAX_INPUT) {
				this.$input.val(MAX_INPUT);
				this.$plus.attr("disabled", true);
			} else {
				this.$plus.removeAttr("disabled");
			}

			if (value < MIN_INPUT) {
				this.$input.val(MIN_INPUT);
				this.$minus.attr("disabled", true);
			}
		});
	}

	getChange() {
		this.$changeCount.on("click", e => {
			const name = $(e.currentTarget).data("name");
			this.getSubscriptionChange(name).then(response => {
				this.$modalContent.html(response);
				this.$modal.addClass("modal_subscription");
				this.$modal.modal("show");
			});
		});
	}

	getPlace(sub_event_id) {
		return this.getSubscriptionPlace(sub_event_id);
	}

	addActionToChooseSeat() {
		this.$chooseSeatButton.on("click", e => {
			this.getSvg(e.currentTarget);
		});
	}

	updateZones(res) {
		let arr = Object.values(res.zones);
		let com = [];
		for (let i = 0; i < arr.length; i++) {
			for (let j = 0; j < com.length; j++) {
				if (com[j] && arr[i]) {
					if (com[j].price === arr[i].price) {
						com[j].free += arr[i].free;
						arr.splice(i, 1);
					}
				}
			}

			if (!com[i] && arr[i]) {
				com.push(arr[i]);
			}
		}
		let obj = {};
		obj.zones = { ...com };
		return obj;
	}

	getSvg(element) {
		this.$modalContent.html("");
		const button = $(element);
		const item = button.parents(".subscription__item");
		this.subUnittId = item.data("unit");
		const name = item.find(".teams").clone();
		const date = item.find(".time").clone();
		const place = item.find(".place").clone();
		this.subEventId = Number(item.data("event"));
		this.getCurrentSubscriptionCartCount(true).then(() => {
			this.getPlaces().then(response => {
				this.zones = response.area.zones;
				this.getPlace(this.subEventId)
					.then(res => {
						this.$modalContent.html(res);
						this.$placesSvg = $(".places__svg");
						this.$places = $("#js-places");
						this.$placesPull = $(".places__pull");
						this.$placesLegend = $(".places__legend");
						this.$placesSum = $(".places__sum");
						this.$placesInfo = $(".places__info");
						this.$placesCancel = $(".places__cancel");
						this.$placesFixed = $(".places__fixed");
						this.$placesBuy = $("#js-places-buy");
						this.$placesPull = $(".order__pull-button");
						this.$prices = $(".places__prices");
						this.$choosePlaces = $(".places__choose");
						this.$chooseSector = $(".places__choose-sector");
						this.$ticketsItems = $(".js-tickets-items");
						this.$placesInfoTop = $(".places__info-top");
						this.$bottom = $(".bottom");
						this.$back = $(".back");
						this.$placesSvg.html(response.area.svg);
						this.$planZoomIn = $("#js-plan-zoom-in");
						this.$planZoomOut = $("#js-plan-zoom-out");
						this.$planZoomReset = $("#js-plan-zoom-reset");
						$(".js-subscription-count").text(this.subscriptionCount);
						this.$tooltip = $(".js-seat-info");
						this.$placesInfoTop.append(name);
						this.$placesInfoTop.append(date);
						this.$placesInfoTop.append(place);
						this.$modal.append(this.$tooltip);
						this.$modal.addClass("modal_subscription modal_place");
						this.$modal.modal({
							show: true,
							backdrop: "static", //не закрывать модалку при нажатии на фон
						});

						if (this.isDesktop.matches) {
							const areaHeight = Math.round(
								this.$placesSvg[0].getBoundingClientRect().height
							);
							$(".places__center").css("min-height", `${areaHeight}px`);
						}

						this.$placesPull.on("click", () => {
							$(".js-tickets").toggle();
							$(".places__svg").toggleClass("inactive");
							$(".places__prices").toggleClass("inactive");
							$(".places__controls").toggleClass("inactive");
							$("html").toggleClass("overflow-hidden");
						});
					})
					.then(() => {
						this.getPrices(0, this.subEventId)
							.then(response => {
								this.$svg = $("#svg");
								this.$placeToSvg = $(".places__svg");
								this.$elements = this.$svg.find("g[mode]");
								$.each(this.$elements, (index, elem) => {
									const element = $(elem);
									let mode = Number(element.attr("mode"));
									if (mode === 1) {
										this.isSectorPlan = true;
									}
								});
								if (this.isSectorPlan) {
									this.setTags();
									this.uniquePrices = {};
									this.zones.forEach(item => {
										this.uniquePrices[item.zone] = item.price;
									});
									this.getZones(this.subEventId).then(res => {
										this.setZones(this.updateZones(res));
										this.addActionToPricesLabelToSector();

										if (!this.isDesktop.matches) {
											$(".places__choose-sector").after($(".places__prices"));
										}
									});
									this.$placesLegend.hide();
									this.$placesInfo.addClass("places__info_sector");
									this.addActionToSector();
									this.$back.removeClass("active");
								} else {
									this.$elements.addClass("default");
									this.setColorToPlace(response);
									this.setPricesLabelToPlace(this.zones);
									this.addActionToPricesLabelToPlace();
									this.$choosePlaces.show();
									this.$chooseSector.hide();
								}

								this.setSvgPlan();
								this.addActionAfterClosePopup();
							})
							.then(() => {
								this.$placesSvg.removeClass("loading");
								if (this.arrayOfPlaces.length) {
									let hasPlaces = false;
									let countTickets = 0;
									const sum = this.$placesSum.find(".js-sum");
									$.each(this.arrayOfPlaces, (index, elem) => {
										if (Number(elem.event_id) === this.subEventId) {
											hasPlaces = true;
											countTickets++;
											const ticket = this.insertDataToTicket(elem, false);
											this.$ticketsItems.append(ticket);
											$("#js-places-choose").text(
												Number($("#js-places-choose").text()) + 1
											);
											$(`#${elem.sid}`)
												.addClass("in-cart")
												.data("available", "false");

											sum.text(Number(sum.text()) + elem.price);
										}
									});
									if (hasPlaces) {
										this.$bottom.addClass("active");
										this.$placesFixed.addClass("active");
										if (
											Number($("#js-places-choose").text()) ===
											this.subscriptionCount
										) {
											this.$placesBuy.removeClass("inactive");
											this.$elements.addClass("inactive");
										}
										$(".js-places-open").addClass("visible");
										$(".js-places-open .js-count").text(countTickets);
										$(".js-places-open .js-count-word").text(
											" " +
												utils.wordEnding(countTickets, [
													this.getWord("event", "ticket"),
													this.getWord("event", "tickets"),
													this.getWord("event", "tickets "),
												])
										);
									}
								}
								if (!this.isSectorPlan) {
									this.addActionToPlaces();
								}
								this.addActionToTicket();
							});
					});
			});
		});
	}

	updateSeatCount(eventId) {}

	addActionToTicket() {
		$("#js-popup-modal .modal-body").on("click", ".tickets_fixed .js-tickets-remove", e => {
			const element = e.currentTarget;
			const parent = $(element).parents(".tickets__item");
			const sid = parent.data("place");
			this.setEventId();
			this.removeFromSubscriptionCart(sid);
			$(`#${sid}`).data("available", "true").removeClass("in-cart");
			parent.remove();
		});
	}

	updateLayoutOnMobile() {
		if (!this.isDesktop.matches) {
			$.each(this.$subscriptionLine, (index, element) => {
				const line = $(element);
				const parent = line.parents(".subscription__item");
				const info = parent.find(".subscription__info");
				const name = parent.find(".subscription__name");
				const price = parent.find(".subscription__price");
				info.after(line);
				name.before(price);
			});
		}
	}

	toggleEvent() {
		$.each(this.$checkboxes, (index, elem) => {
			const checkbox = $(elem);
			const parent = checkbox.parents(".subscription__item");

			checkbox.on("change", () => {
				this.subEventId = Number(parent.data("event"));
				if (checkbox.is(":checked")) {
					this.addSubscriptionEvent().then(() => {
						this.calculateTotalSumm();
					});
				} else {
					this.removeSubscriptionEvent().then(() => {
						const item = $(`.subscription__item[data-event="${this.subEventId}"]`);
						item.find(".tickets").remove();
						item.find(".js-subscription-choose").show();
						let selected = 0;
						$.each($(`.subscription__item`), (index, item) => {
							if ($(item).find(".tickets__item").length > 0) {
								selected++;
							}
						});
						this.$selectedCount.text(selected);
						const prices = $(".js-ticket-price");
						let sum = 0;
						$.each(prices, (index, element) => {
							const price = $(element);
							sum += Number(price.text());
						});
						this.getCartCount().then(res => {
							$.each(res, (i, it) => {
								$.each(it.carts, (index, item) => {
									const cart = $(`.tickets__item[data-uid="${item.uid}"]`);
									const price = cart.find(".js-ticket-price");
									price.data("price", item.price);
									price.data("default", item.default_price);
									price.text(item.default_price);
								});
							});

							this.calculateTotalSumm();
						});
					});
				}
			});
		});
	}

	changeSeats() {
		this.$changeSeatsButton.on("click", e => {
			const element = $(e.currentTarget);
			const parent = element.parents(".subscription__item");
			this.subEventId = parent.data("event");
			this.getChangeSeats().then(res => {
				if (res.result === true) {
					this.getSvg(e.currentTarget);
					this.$selectedCount.text(Number(this.$selectedCount.text()) - 1);
					//this.$buy.addClass("disabled");
					const prices = parent.find(".js-ticket-price");
					let disSum = 0;
					$.each(prices, (index, el) => {
						const price = Number($(el).text());
						disSum += price;
					});
					//this.$sum.text(Number(this.$sum.text()) - disSum);
					parent.find(".tickets").remove();
					element.remove();
					parent.find(".js-subscription-choose").show();
				} else {
					window.location.reload(); //прошло 30мин
				}
			});
		});
	}

	addActionAfterClosePopup() {
		this.$placesCancel.on("click", () => {
			$.each(this.$elements, (index, elem) => {
				const element = $(elem);
				if (element.hasClass("in-cart")) {
					const sid = element.attr("id");
					element.data("available", "true");
					this.removeFromSubscriptionCart(sid);
				}
			});
			$("#js-popup-modal .modal-body").off();
			$("#js-popup-modal.modal_subscription").modal("hide");
			this.calculateTotalSumm(); //обновить стоимость
		});
	}

	checkAllEvents() {
		if (!this.$checkboxAll.is(":checked")) {
			this.$checkboxAll.prop("checked", true);
			this.$checkboxes.prop("checked", true);
			this.$checkedCount.text(this.allCheckboxesLength);
			$.each(this.$checkboxes, (index, elem) => {
				const checkbox = $(elem);
				const parent = checkbox.parents(".subscription__item");
				this.subEventId = parent.data("event");
				parent.find(".subscription__choose").removeClass("inactive");
			});
		} else {
			if (this.eventId) {
				this.addAllEvents();
			}
		}
	}

	checkBuyButton() {
		if (
			this.$sum.text() == "" ||
			this.$sum.text() == 0 ||
			$(".js-subscription-selected").text() == 0 ||
			$(".js-subscription-checked").first().text() != $(".js-subscription-selected").text()
		) {
			this.$buy.addClass("disabled");
		}

		if (
			$(".js-subscription-selected").text() == $(".js-subscription-checked").first().text() &&
			$(".js-subscription-selected").text() != 0
		) {
			this.$buy.removeClass("disabled");
		}
	}
}
